import { render, staticRenderFns } from "./SbInvoiceInbound.vue?vue&type=template&id=bc295fcc&"
import script from "./SbInvoiceInbound.vue?vue&type=script&lang=js&"
export * from "./SbInvoiceInbound.vue?vue&type=script&lang=js&"
import style0 from "./SbInvoiceInbound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports